//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {parseTime} from '@/util/index.js'

export default {
    props:{
        barType:{
            type:Number,
            default:1,
        },
        type_option:{
            type:Array,
            default:() => []
        },
        tabList:{
            type:Array,
            default:() => []
        }
    },
    data() {
        return {
            is_search:false,
            searchValue:'',
            actived_tab: -1,
            option1: [
                { text: '全部工单', value: -1 },
            ],
            option2: [
                { text: '全部任务', value: -1 },
            ],
            // 状态
            actived:-1,
            // 排序
            show:false,
            sort_id:'',  // 排序类型
            sort_type:'',  // 0 升序 1 降序
            show_option_one:[
                { text: '工单编号', value: 1, },
                { text: '产品名称', value: 2, },
                { text: '产品规格', value: 3, },
                { text: '创建时间', value: 4, },
                { text: '计划开始时间', value: 5, },
                { text: '计划结束时间', value: 6, },
            ],
            show_option_two:[
                { text: '工单编号', value: 1, },
                { text: '产品名称', value: 2, },
                { text: '计划开始时间', value: 5, },
                { text: '计划结束时间', value: 6, },
            ],
            // 筛选
            filter:false,
            // 基础筛选
            basis_type: '',
            // 计划开始时间
            is_planStartTime:false,  // false 快捷按钮 true 准确输入
            planStartTime_type:'',
            planStart_one:'',
            planStart_two:'',
            // 计划结束时间
            is_planEndTime:false,
            planEndTime_type:'',
            planEnd_one:'',
            planEnd_two:'',
            // 实际开始实际
            is_actualStartTime:false,
            actualStartTime_type:'',
            actualStart_one:'',
            actualStart_two:'',
            // 实际结束实际
            is_actualEndTime:false,
            actualEndTime_type:'',
            actualEnd_one:'',
            actualEnd_two:'',
            // 备注
            remark:'',
            // 时间选择
            time:false,
            timeTitle:'选择时间',
            actvied_t:'',
            actived_i:'',
            minDate: new Date(2018, 0, 1),
            maxDate: new Date(2030, 10, 1),
            currentDate: new Date(),
        }
    },
    methods:{
        // 列表切换
        tabChange(value){
            this.$emit('tabChange',value)
        },

        // 搜索
        onSearch(){
            this.is_search = true
        },
        Search(){
            this.$emit('onSearch',this.searchValue)
        },
        Cancel(){
            this.is_search = false
            this.$emit('onSearch',this.searchValue)
        },

        // 排序
        onSort(){
            this.show = true
        },
        onSorting(id,type){
            this.sort_id = id
            this.sort_type = type
            let orders = {
                orderBy:'',
                sort:'',
            }
            switch (this.sort_id) {
                case 1:
                    orders.orderBy = 'order_number'
                    break;
                case 2:
                    orders.orderBy = 'product_name'
                    break;
                case 3:
                    orders.orderBy = 'specification'
                    break;
                case 4:
                    orders.orderBy = 'create_time'
                    break;
                case 5:
                    orders.orderBy = 'scheduled_start_time'
                    break;
                case 6:
                    orders.orderBy = 'scheduled_end_time'
                    break;
                default:
                    break;
            }
            switch (this.sort_type) {
                case 0:
                    orders.sort = 'asc '
                    break;
                case 1:
                    orders.sort = 'desc'
                    break;
                default:
                    break;
            }

            this.$emit("changeOrders",orders)
        },

        // 筛选
        onFilter(){
            this.filter = true
        },
        changeFilter(i){ 
            if(i == 1){
                this.is_planStartTime = !this.is_planStartTime
            }else if(i == 2){
                this.is_planEndTime = !this.is_planEndTime
            }else if(i == 3){
                this.is_actualStartTime = !this.is_actualStartTime
            }else if(i == 4){
                this.is_actualEndTime = !this.is_actualEndTime
            }
        },
        // 重置数据
        filterReset(){
            this.basis_type = ''
            this.is_planStartTime = false
            this.planStartTime_type = ''
            this.planStart_one = '',
            this.planStart_two = '',
            this.is_planEndTime = false
            this.planEndTime_type = ''
            this.planEnd_one ='',
            this.planEnd_two = '',
            this.is_actualStartTime = false
            this.actualStartTime_type = ''
            this.actualStart_one = '',
            this.actualStart_two = '',
            this.is_actualEndTime = false
            this.actualEndTime_type = ''
            this.actualEnd_one = '',
            this.actualEnd_two = '',
            this.remark = ''
        },
        // 基础筛选选择
        onBasisFilter(i){
            if(this.basis_type == i){
                this.basis_type = ''
            }else{
                this.basis_type = i
            }
        },
        // 时间按钮选择
        onTimeFilter(type,i){
            if(type == 1){
                if(this.planStartTime_type == i){
                    this.planStartTime_type = ''
                }else{
                    this.planStartTime_type = i
                } 
            }else if(type == 2){
                if(this.planEndTime_type == i){
                    this.planEndTime_type = ''
                }else{
                    this.planEndTime_type = i
                }  
            }else if(type == 3){
                if(this.actualStartTime_type == i){
                    this.actualStartTime_type = ''
                }else{
                    this.actualStartTime_type = i
                }
            }else if(type == 4){
                if(this.actualEndTime_type == i){
                    this.actualEndTime_type = ''
                }else{
                    this.actualEndTime_type = i
                }
            }
        },
        // 时间选择
        onShowTime(type,i){
            if(i == 1){
                this.timeTitle = '开始时间'
            }else{
                this.timeTitle = '结束时间'
            }
            this.actvied_t = type
            this.actived_i = i
            this.time = true
        },
        confirm(value){
            const t = this.actvied_t  
            const i = this.actived_i // 1开始 2结束
            if(t == 1){
                if(i == 1){
                    this.planStart_one = parseTime(value)
                }else{
                    this.planStart_two = parseTime(value)
                }
            }else if(t == 2){
                if(i == 1){
                    this.planEnd_one = parseTime(value)
                }else{
                    this.planEnd_two = parseTime(value)
                }
            }else if(t == 3){
                if(i == 1){
                    this.actualStart_one = parseTime(value)
                }else{
                    this.actualStart_two = parseTime(value)
                }
            }else if(t == 4){
                if(i == 1){
                    this.actualEnd_one = parseTime(value)
                }else{
                    this.actualEnd_two = parseTime(value)
                }
            }
            this.time = false
        },
        cancel(){
            this.time = false
        },

        // 确定筛选
        SaveFilter(){
            let filterData = {
                is_urgent:'',
                is_over_time :'',
                start_time:[],
                end_time:[],
                scheduled_start_time:[],
                scheduled_end_time:[],
                remark:this.remark,
                status:'',
            }
            // 1工单页面筛选  2任务页面筛选
            if(this.barType == 1){
                filterData.is_urgent = this.basis_type == 1 ? '1' : ''
                filterData.is_over_time = this.basis_type == 2 ? '1' : ''
            }else if(this.barType == 2){
                filterData.is_urgent = this.basis_type == 1 ? '1' : ''
                if(this.basis_type == 2){
                    filterData.status = 0
                }else if(this.basis_type == 3){
                    filterData.status = 1
                }else if(this.basis_type == 4){
                    filterData.status = 2
                }
            }

            // 计划开始时间
            if(this.is_planStartTime){ // true 准确实际 false 快捷按钮
                filterData.scheduled_start_time[0] = new Date(this.$SET_DATE(this.planStart_one)).getTime() / 1000
                filterData.scheduled_start_time[1] = new Date(this.$SET_DATE(this.planStart_two)).getTime() / 1000 
            }else{
                if(this.planStartTime_type == 1){   // 今天
                    filterData.scheduled_start_time[0] = new Date(new Date().setHours(0, 0, 0, 0)).getTime() / 1000
                    filterData.scheduled_start_time[1] = new Date(new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000).getTime() / 1000;
                }else if(this.planStartTime_type == 2){   // 昨天
                    filterData.scheduled_start_time[0] = new Date(new Date().setHours(0, 0, 0, 0) - 24 * 60 * 60 * 1000).getTime() / 1000
                    filterData.scheduled_start_time[1] = new Date(new Date().setHours(0, 0, 0, 0)).getTime() / 1000
                }
            }
            // 计划结束时间
            if(this.is_planEndTime){ // true 准确实际 false 快捷按钮
                filterData.scheduled_end_time[0] = new Date(this.$SET_DATE(this.planEnd_one)).getTime() / 1000
                filterData.scheduled_end_time[1] = new Date(this.$SET_DATE(this.planEnd_two)).getTime() / 1000 
            }else{
                if(this.planEndTime_type == 1){   // 今天
                    filterData.scheduled_end_time[0] = new Date(new Date().setHours(0, 0, 0, 0)).getTime() / 1000
                    filterData.scheduled_end_time[1] = new Date(new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000).getTime() / 1000;
                }else if(this.planEndTime_type == 2){   // 昨天
                    filterData.scheduled_end_time[0] = new Date(new Date().setHours(0, 0, 0, 0) - 24 * 60 * 60 * 1000).getTime() / 1000
                    filterData.scheduled_end_time[1] = new Date(new Date().setHours(0, 0, 0, 0)).getTime() / 1000
                }
            }
            // 实际开始时间
            if(this.is_actualStartTime){ // true 准确实际 false 快捷按钮
                filterData.start_time[0] = new Date(this.$SET_DATE(this.actualStart_one)).getTime() / 1000
                filterData.start_time[1] = new Date(this.$SET_DATE(this.actualStart_two)).getTime() / 1000 
            }else{
                if(this.actualStartTime_type == 1){   // 今天
                    filterData.start_time[0] = new Date(new Date().setHours(0, 0, 0, 0)).getTime() / 1000
                    filterData.start_time[1] = new Date(new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000).getTime() / 1000;
                }else if(this.actualStartTime_type == 2){   // 昨天
                    filterData.start_time[0] = new Date(new Date().setHours(0, 0, 0, 0) - 24 * 60 * 60 * 1000).getTime() / 1000
                    filterData.start_time[1] = new Date(new Date().setHours(0, 0, 0, 0)).getTime() / 1000
                }
            }
            // 实际结束时间
            if(this.is_actualEndTime){ // true 准确实际 false 快捷按钮
                filterData.end_time[0] = new Date(this.$SET_DATE(this.actualEnd_one)).getTime() / 1000
                filterData.end_time[1] = new Date(this.$SET_DATE(this.actualEnd_two)).getTime() / 1000 
            }else{
                if(this.actualEndTime_type == 1){   // 今天
                    filterData.end_time[0] = new Date(new Date().setHours(0, 0, 0, 0)).getTime() / 1000
                    filterData.end_time[1] = new Date(new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000).getTime() / 1000;
                }else if(this.actualEndTime_type == 2){   // 昨天
                    filterData.end_time[0] = new Date(new Date().setHours(0, 0, 0, 0) - 24 * 60 * 60 * 1000).getTime() / 1000
                    filterData.end_time[1] = new Date(new Date().setHours(0, 0, 0, 0)).getTime() / 1000
                }
            }

            // console.log(filterData);
            this.filter = false
            this.$emit('saveFilterData',filterData)
        },

        // 状态切换
        changeType(i){
            this.actived = i
            this.$emit('changeType',i)
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/home/component/NavBar.vue